module.exports = __webpack_public_path__ + "img/gu.c3db56a.svg";